export default "__VITE_ASSET__DWybw4R0__"